<template>
  <v-container fluid>
    <v-form :readonly="true">
      <v-row dense>
        <v-col cols="12">
          <v-card class="rounded-lg">
            <v-card-title class="am-t2 bold">
              <v-row dense class="space-between align-center">
                <div>
                  Informations générales de l'association
                </div>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-text-field
                filled
                dense
                label="Dénomination"
                :value="informations.denomination"
              />
              <v-row dense>
                <v-col cols="6">
                  <v-text-field
                    filled
                    dense
                    label="Numéro RNA"
                    :value="informations.reference"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    filled
                    dense
                    label="Numéro SIRET/SIREN"
                    :value="informations.numero"
                  />
                </v-col>
              </v-row>
              <v-textarea
                dense
                filled
                label="Objet"
                :value="informations.objet"
              />
              <v-row dense>
                <v-col cols="6">
                  <a-domaine-select
                    dense
                    filled
                    label="Domaine"
                    :value="informations.domaine"
                  />
                </v-col>
                <v-col cols="6">
                  <a-theme-select
                    dense
                    filled
                    label="Thèmes"
                    :domaine="informations.domaine"
                    :value="informations.theme"
                  />
                </v-col>
                <v-col cols="6">
                  <a-gouvernance-combobox
                    dense
                    filled
                    label="Représentant légal"
                    :value="informations.gouvernance"
                  />
                </v-col>
                <v-col cols="6">
                </v-col>
                <v-col cols="12">
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        filled
                        label="Adresse du siège"
                        :value="informations.adresse.adresse"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        filled
                        label="Complément d'adresse"
                        :value="informations.adresse.complementAdresse"
                      />
                    </v-col>
                   <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        filled
                        label="Code postal"
                        :value="informations.adresse.codePostal"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <a-commune-autocomplete
                        dense
                        filled
                        label="Commune du siège"
                        :value="informations.adresse.commune"
                        :codePostal="informations.adresse.codePostal"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        dense
                        filled
                        label="Domiciliation"
                        :value="informations.adresse.domiciliation"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        filled
                        label="Date assemblée constitutive"
                        type="date"
                        readonly
                        :value="dateConstitutive"
                        hint="Cette date est déterminée à partir des documents de l'association."
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        filled
                        label="Date des derniers statuts"
                        type="date"
                        readonly
                        :value="dateStatuts"
                        hint="Cette date est déterminée à partir des documents de l'association."
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        filled
                        label="Date de publication d'inscription au JAL"
                        type="date"
                        :value="dateInscriptionJAL"
                        hint="Cette date est déterminée à partir des documents de l'association."
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <a-duree-field
                        dense
                        filled
                        label="Durée de l'association"
                        :value="informations.dureeValidite"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        filled
                        clearable
                        label="Date de l'expiration de l'association"
                        type="date"
                        :value="informations.finValidite"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <a-duree-field
                        dense
                        filled
                        label="Fréquence de renouvellement de la direction en jours"
                        :value="informations.dureeRenouvellement"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        filled
                        label="Date de dissolution"
                        type="date"
                        readonly
                        :value="dateDissolution"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        filled
                        label="Date de publication de la dissolution au JAL"
                        type="date"
                        readonly
                        :value="dateDissolutionJAL"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        filled
                        label="Date de radiation"
                        type="date"
                        :value="dateRadiation"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        dense
                        filled
                        label="Adresse du site internet de l'association"
                        :value="informations.adresseSite"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        filled
                        label="Adresse courriel de l'association"
                        :value="informations.adresseCourriel"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-checkbox
                        v-model="informations.consentementCommunication"
                        label="Consentement à la communication électronique"
                      />
                    </v-col>
                  </v-row>
                  <a-but-association-switch
                    dense
                    filled
                    :value="informations.but"
                    vrai="LUCRATIF"
                    faux="NON_LUCRATIF"
                  />
                  <v-checkbox
                    v-model="informations.cooperative"
                    label="Coopérative"
                  />
                  <v-checkbox
                    v-model="informations.utilitePublique"
                    label="Mission d'utilité publique"
                  />
                  <v-checkbox
                    v-model="informations.stipulations"
                    label="Restrictions de l'étendue du pouvoir de représentation de la direction ou dérogeant aux règles de l'article 28 alinéa 1 relatives au pouvoir de la  direction"
                  />
                  <v-textarea
                    v-if="informations.stipulations"
                    dense
                    filled
                    label="Précision sur les stipulations"
                    :value="informations.precisionStipulation"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <template v-if="estLiquidee">
          <v-col cols="12">
            <v-card class="rounded-lg">
              <v-card-title class="am-t2 bold">
                Informations de dissolution
              </v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      dense
                      filled
                      label="Commentaire"
                      :value="liquidationAssociation.commentaireLiquidation"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </template>

        <template v-if="estRadiee">
          <v-col cols="12">
            <v-card class="rounded-lg">
              <v-card-title class="am-t2 bold">
                Informations de radiation
              </v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="4" md="2">
                    <v-checkbox
                      dense
                      label="Quitus"
                      v-model="radiationAssociation.quitus"
                    />
                  </v-col>
                  <v-col cols="8" md="4">
                    <v-text-field
                      dense
                      filled
                      label="Date de l'ordonnance de dissolution"
                      type="date"
                      :value="radiationAssociation.dateDissolution"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      dense
                      filled
                      label="Commentaire"
                      :value="radiationAssociation.commentaireRadiation"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import makeSaisieComponent from "@/mixins/forms/makeSaisieComponent";

export default {
  mixins: [makeSaisieComponent()],
};
</script>

